import React from "react";
import "./navbar.css";

export const NavEvent = (props) => {
  return <h1 className="navEvent">{props.navEvent}</h1>;
};
